import React from 'react';
import { AlertCircle, X } from 'lucide-react';

/**
 * 실패를 사람에게 보인다(2026-10-08, #107). 저장 · 판정 · 반영이 실패해도 버튼만 돌아와
 * 「됐다」고 믿게 되던 곳에 쓴다. 「다시 시도」가 있으면 버튼을 붙인다
 */
export const ErrorBanner: React.FC<{ message: string | null; onClose?: () => void; onRetry?: () => void; className?: string }> = ({ message, onClose, onRetry, className = '' }) =>
  message ? (
    <div role="alert" className={`flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700 ${className}`}>
      <AlertCircle size={16} className="mt-0.5 flex-shrink-0" />
      <span className="flex-1 break-words">{message}</span>
      {onRetry && <button onClick={onRetry} className="flex-shrink-0 rounded px-2 py-0.5 text-xs font-medium border border-red-300 hover:bg-red-100">다시 시도</button>}
      {onClose && <button onClick={onClose} title="닫기" className="flex-shrink-0 rounded p-0.5 text-red-400 hover:bg-red-100 hover:text-red-600"><X size={14} /></button>}
    </div>
  ) : null;

/** 잡힌 오류를 문장으로 */
export const errorText = (e: unknown, fallback = '처리하지 못했습니다'): string =>
  e instanceof Error && e.message ? e.message : fallback;
